import { IUser, UserSubscriptionStatus } from '../../types';
import { AvailablePaymentMethod } from '../../reducers/payments';

export const delay = async (timeMs: number): Promise<void> =>
  new Promise((resolve) => {
    setTimeout(resolve, timeMs);
  });

export const shortPollTillTrue = async (
  fn: () => Promise<boolean>,
  options: { interval: number; retryTimes: number }
): Promise<boolean> => {
  let result = false;
  let attempt = 0;

  while (true) {
    attempt += 1;
    // eslint-disable-next-line no-await-in-loop
    result = await fn();

    if (result) {
      break;
    }

    if (attempt >= options.retryTimes) {
      break;
    }

    // eslint-disable-next-line no-await-in-loop
    await delay(options.interval);
  }

  return result;
};

export const isSubscriptionToBeCanceled = (
  subscriptionStatus?: UserSubscriptionStatus
) => subscriptionStatus === UserSubscriptionStatus.CANCELING;

export const isSubscriptionCancelable = (
  subscriptionStatus?: UserSubscriptionStatus
) =>
  !isSubscriptionToBeCanceled(subscriptionStatus) &&
  subscriptionStatus !== UserSubscriptionStatus.CANCELED &&
  subscriptionStatus !== UserSubscriptionStatus.NONE &&
  subscriptionStatus !== UserSubscriptionStatus.TRIALING;

export const isSubscriptionStatusActive = (
  subscriptionStatus?: UserSubscriptionStatus
): boolean =>
  subscriptionStatus === UserSubscriptionStatus.ACTIVE ||
  subscriptionStatus === UserSubscriptionStatus.TRIALING ||
  subscriptionStatus === UserSubscriptionStatus.CANCELING;

export const isUserSubscriptionStatusActive = (user: IUser): boolean =>
  isSubscriptionStatusActive(user.subscriptionStatus);

export const formatCardNumber = (last4: string): string =>
  last4.padStart(16, '*');

export const getFormattedCardNumber = (card: AvailablePaymentMethod): string =>
  formatCardNumber(card.last4);
